import { createFileRoute } from '@tanstack/react-router';
import ThirdPartyAccess from '../components/pages/third-party-access';

export const Route = createFileRoute('/')({
  component: ThirdPartyAccess,
});
